var bronze = "/static/56ead821ad5b424b.png";

export { bronze as default };
//# sourceMappingURL=bronze.png.js.map
